import Url from '../util/Url'

export const obterGPS = address => {

    return new Promise((resolve,reject) => {
        const url = Url.obterUrlApi() + "/dados/gps/obterGPS"
        let resposta = null
        const metodo = "POST"
        const xmlhttp = new XMLHttpRequest()
        if (!xmlhttp) {
            resposta = { tipo:'problema', texto:'Erro obtendo xmlhttp!' }
            reject(resposta)
            return
        }

        xmlhttp.onload = () => {
            resposta = xmlhttp.responseText
            if (typeof resposta === 'string') {
                if (resposta.includes('{')) {
                    resposta = JSON.parse(resposta)
                } else if (resposta === '[]') {
                    resposta = []
                }
            }
            if (xmlhttp.status === 200) {
                resolve(resposta)
            } else {
                reject(resposta)
            }
            return
        }

        xmlhttp.open(metodo,url,true)
        xmlhttp.setRequestHeader('Content-Type', 'application/json; charset=utf-8')
        xmlhttp.send(JSON.stringify(address))    
    });
}

export const obterEndereco = gps => {

    return new Promise((resolve,reject) => {
        
        const url = Url.obterUrlApi() + "/dados/gps/obterEndereco"
        let resposta = null
        const metodo = "POST"
        const xmlhttp = new XMLHttpRequest()
        if (!xmlhttp) {
            resposta = { tipo:'problema', texto:'Erro obtendo xmlhttp!' }
            reject(resposta)
            return
        }

        xmlhttp.onload = () => {
            resposta = xmlhttp.responseText
            if (typeof resposta === 'string') {
                if (resposta.includes('{')) {
                    resposta = JSON.parse(resposta)
                } else if (resposta === '[]') {
                    resposta = []
                }
            }
            if (xmlhttp.status === 200) {
                resolve(resposta)
            } else {
                reject(resposta)
            }
            return
        }

        xmlhttp.open(metodo,url,true)
        xmlhttp.setRequestHeader('Content-Type', 'application/json; charset=utf-8')
        xmlhttp.send(JSON.stringify(gps))    
    });
}